export const VALUE_SCORE = {
  CREDIT_SCORE: 3,
  PERFORMANCE: 2,
  // CORPORATE_RISK: 3,
}

export const TYPE_SELECT_SCORE = [
  {
    label: 'portfolioScore.creditRisk',
    value: VALUE_SCORE.CREDIT_SCORE,
    isI18n: true,
  },
  {
    label: 'portfolioScore.performance',
    value: VALUE_SCORE.PERFORMANCE,
    isI18n: true,
  },
]

export const COLUMN_ID_TABLE = {
  PREVIOUS: 'previousLevel',
  TREND: 'trend',
  CURRENT: 'currentLevel',
  NUMBER_OF_COMPANY: 'numOfCompanies',
  PERCENT: 'percentage',
  ICON_DELETE: 'iconDelete',
}

export const TITLE_TABLE_SCORE_TREND = [
  {
    title: 'portfolioScore.previousLevel',
    key: COLUMN_ID_TABLE.PREVIOUS,
    thStyle: {
      justifyContent: 'start',
      textAlign: 'left',
    },
    tdStyle: { width: '50%' },
  },
  {
    title: 'portfolioScore.trend',
    key: COLUMN_ID_TABLE.TREND,
    thStyle: {
      justifyContent: 'center',
      textAlign: 'center',
    },
    tdStyle: {
      justifyContent: 'center',
      textAlign: 'center',
    },
  },
  {
    title: 'portfolioScore.currentLevel',
    key: COLUMN_ID_TABLE.CURRENT,
    thStyle: {
      justifyContent: 'start',
      textAlign: 'left',
    },
    tdStyle: { width: '50%' },
  },
  {
    title: 'portfolioScore.numberOfCompanies',
    key: COLUMN_ID_TABLE.NUMBER_OF_COMPANY,
    thStyle: {
      justifyContent: 'end',
      textAlign: 'right',
    },
    tdStyle: {
      justifyContent: 'end',
      textAlign: 'right',
    },
  },
  {
    title: 'portfolioScore.percentOfTotal',
    key: COLUMN_ID_TABLE.PERCENT,
    thStyle: {
      justifyContent: 'end',
      textAlign: 'right',
    },
    tdStyle: {
      justifyContent: 'end',
      textAlign: 'right',
    },
  },
]

export const TITLE_TABLE_CHANGE_SCORE_TREND = [
  {
    title: 'portfolioScore.previousLevel',
    key: COLUMN_ID_TABLE.PREVIOUS,
    thStyle: {
      justifyContent: 'start',
      textAlign: 'left',
    },
    tdStyle: { width: '50%' },
  },
  {
    title: 'portfolioScore.trend',
    key: COLUMN_ID_TABLE.TREND,
    thStyle: {
      justifyContent: 'center',
      textAlign: 'center',
    },
    tdStyle: {
      justifyContent: 'center',
      textAlign: 'center',
    },
  },
  {
    title: 'portfolioScore.currentLevel',
    key: COLUMN_ID_TABLE.CURRENT,
    thStyle: {
      justifyContent: 'start',
      textAlign: 'left',
    },
    tdStyle: { width: '50%' },
  },
  {
    title: '',
    key: COLUMN_ID_TABLE.ICON_DELETE,
    thStyle: {
      justifyContent: 'center',
      textAlign: 'center',
    },
  },
]

export const SCORE_TYPE = {
  CREDIT_RISK: 'CREDIT_RISK',
  PERFORMANCE: 'PERFORMANCE',
}

export const PERFORMANCE_SCORE_COLOR = [
  '#87D4A4',
  '#C3D785',
  '#FFDE86',
  '#EB6671',
  '#9c9c9c',
]

export const TREND_SCORE = {
  UP: 'UP',
  DOWN: 'DOWN',
  UNDEFINED: 'UNDEFINED',
}

export const TYPE_SELECT_TREND_SCORE = [
  {
    label: TREND_SCORE.UP,
    value: TREND_SCORE.UP,
  },
  {
    label: TREND_SCORE.DOWN,
    value: TREND_SCORE.DOWN,
  },
  {
    label: TREND_SCORE.UNDEFINED,
    value: TREND_SCORE.UNDEFINED,
  },
]

export const ITEM_ANY_RISK = {
  label: 'portfolioScore.anyRisk',
  scoreRangeId: 0,
  isI18n: true,
  color: '#E9E9E9',
}

export const ITEM_ANY_POTENTIAL = {
  label: 'portfolioScore.anyPotential',
  scoreRangeId: 0,
  isI18n: true,
  color: '#E9E9E9',
}

export const COLORS_TREND = {
  [TREND_SCORE.DOWN]: '#E0505B',
  [TREND_SCORE.UP]: '#3DA967',
  [TREND_SCORE.UNDEFINED]: '#006AA6',
}
